import * as React from 'react';
import {useContext} from 'react';
import axiosApiInstance from "../../../api/axiosClient";
import {GlobalStateContext} from "../../../context/GlobalContext";
import {Button} from "antd";
import {ModalForm} from '@ant-design/pro-components';
import {DeleteOutlined} from "@ant-design/icons";

type Props = {
    id?: number
};

const DeleteCreatorLead = (props: Props) => {
    const {creatorsLeadsTableRef} = useContext(GlobalStateContext);

    return (
        <ModalForm
            width={400}
            title={"Delete Lead"}
            trigger={
                <Button type={"text"} icon={<DeleteOutlined/>} danger
                    // icon={<DeleteOutlined/>}
                />
            }
            submitter={{submitButtonProps: {danger: true}}}
            autoFocusFirstInput
            modalProps={{
                destroyOnClose: true,
                okText: 'Delete',
                cancelText: 'No'
            }}
            onFinish={async (values) => {
                return axiosApiInstance.delete(`/api/leads/items/${props.id}`)
                    .then(res => {
                        // console.log(res)
                        creatorsLeadsTableRef?.current?.reload()
                        return true
                    }).catch(reason => false)
            }}
        >
            Are you sure?
        </ModalForm>
    );
};

export default DeleteCreatorLead;